(function () {
  'use strict';
  if (window.CartTransferV1) return;
  let dialog, title, detail, timer, startedAt;
  const audit = new URL(location.href).searchParams.has("ms_speed_audit");
  if(location.pathname.endsWith("/cart")){try{const raw=sessionStorage.getItem("ms-cart-audit");if(raw){const timing=JSON.parse(raw);timing.cartReadyMs=Date.now()-timing.startedAt;const meta=document.createElement("meta");meta.name="ms-cart-audit";meta.content=JSON.stringify(timing);document.head.append(meta);sessionStorage.removeItem("ms-cart-audit");}}catch{}}
  const words = JSON.parse(document.getElementById('ms-cart-transfer-messages').textContent);
  function build() {
    if (dialog) return;
    const style = document.createElement('style');
    style.textContent = '.ms-transfer{border:0;border-radius:22px;padding:32px 26px;width:min(420px,calc(100vw - 32px));box-sizing:border-box;text-align:center;background:var(--color-background,#fff);color:var(--color-foreground,#28211b);box-shadow:0 18px 80px #0003;font-family:var(--font-body--family,Arial,sans-serif)}.ms-transfer::backdrop{background:#211b17aa}.ms-transfer h2{font-size:22px;line-height:1.3;margin:22px 0 12px}.ms-transfer p{font-size:15px;line-height:1.6;margin:0;color:inherit;opacity:.8}.ms-transfer-ring{width:62px;height:62px;margin:auto;border:5px solid #f0e8dc;border-top-color:#a87c4b;border-radius:50%;animation:ms-turn .9s linear infinite}.ms-transfer-track{height:7px;overflow:hidden;border-radius:9px;background:#f0e8dc;margin-block-start:24px}.ms-transfer-track:before{content:"";display:block;width:36%;height:100%;border-radius:9px;background:#a87c4b;animation:ms-slide 1.5s ease-in-out infinite alternate}@keyframes ms-turn{to{transform:rotate(360deg)}}@keyframes ms-slide{to{transform:translateX(178%)}}@media(prefers-reduced-motion:reduce){.ms-transfer-ring,.ms-transfer-track:before{animation:none}}';
    document.head.append(style);
    dialog = document.createElement('dialog'); dialog.className = 'ms-transfer';
    dialog.setAttribute('aria-labelledby', 'ms-transfer-title'); dialog.setAttribute('aria-describedby', 'ms-transfer-detail');
    const ring = document.createElement('div'); ring.className = 'ms-transfer-ring'; ring.setAttribute('aria-hidden','true');
    title = document.createElement('h2'); title.id = 'ms-transfer-title'; title.setAttribute('aria-live','polite');
    detail = document.createElement('p'); detail.id = 'ms-transfer-detail';
    const track = document.createElement('div'); track.className = 'ms-transfer-track'; track.setAttribute('aria-hidden','true');
    dialog.append(ring,title,detail,track); document.body.append(dialog);
  }
  function begin() {
    startedAt=Date.now();build(); clearTimeout(timer); title.textContent = words.preparing; detail.textContent = words.wait;
    if (!dialog.open) dialog.showModal();
    timer = setTimeout(() => { detail.textContent = words.longer; }, 6000);
  }
  function fail() { clearTimeout(timer); if(dialog?.open)dialog.close(); }
  async function send(form, payload) {
    if (!dialog?.open) begin();
    title.textContent = words.sending;
    const root = window.Shopify?.routes?.root || '/';
    try {
      const uploadAt=Date.now(),body=payload || new FormData(form);
      const bytes=audit?[...body.values()].reduce((n,v)=>n+(v instanceof Blob?v.size:0),0):0;
      const response = await fetch(root + 'cart/add.js', { method:'POST', body, headers:{Accept:'application/json'} });
      const result = await response.json();
      if (!response.ok) throw Error(result.description || words.failed);
      if(audit){try{sessionStorage.setItem("ms-cart-audit",JSON.stringify({startedAt,preparationMs:uploadAt-startedAt,uploadMs:Date.now()-uploadAt,savedMs:Date.now()-startedAt,bytes,printTiming:form.dataset.msPrintTiming?JSON.parse(form.dataset.msPrintTiming):undefined}));}catch{}}
      title.textContent = words.opening; clearTimeout(timer);
      window.location.assign(root + 'cart');
      return result;
    } catch(error) { fail(); throw error; }
  }
  // Preparation and upload stay on this document; navigation follows a confirmed cart response.
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || event.defaultPrevented) return;
    const root = form.closest('momente-photo-editor,gift-personalizer,phone-case-personalizer,photo-mat-personalizer,text-mat-personalizer,keychain-personalizer,[data-pfp-ready]');
    if (!root) return;
    const buy = form.querySelector('[data-buy],[data-editor-buy],.pfp-cart-button');
    if (buy && !buy.disabled) begin();
  }, true);
  const warmed = new WeakMap(),tails = new WeakMap();
  function exportKey(root){return JSON.stringify([root.querySelector('[data-design-data]')?.value,root.querySelector('[name="id"]')?.value,root.fileSequence,root.image?.src]);}
  function jobFor(root,producer,key){
    const previous=warmed.get(root);if(previous?.key===key)return previous;
    clearTimeout(previous?.timer);
    const job={key,producer};warmed.set(root,job);return job;
  }
  function start(root,job){
    clearTimeout(job.timer);if(job.promise)return job.promise;
    const previous=tails.get(root);
    job.promise=(async()=>{
      if(previous)await previous;
      if(warmed.get(root)!==job)throw Error("Superseded design preparation");
      const sink=document.createElement('div'),form=document.createElement('form'),preview=document.createElement('input');
      preview.type='file';preview.name='properties[Designvorschau]';preview.dataset.designFile='';form.append(preview);sink.append(form);
      await job.producer(sink);job.printTiming=form.dataset.msPrintTiming;
      return [...new FormData(form)];
    })();
    tails.set(root,job.promise.then(()=>{},()=>{}));
    job.promise.catch(()=>{if(warmed.get(root)===job)warmed.delete(root);});return job.promise;
  }
  function queue(root,producer,key=exportKey(root)){
    const previous=warmed.get(root),job=jobFor(root,producer,key);if(previous===job)return;
    job.timer=setTimeout(()=>{if(root.isConnected&&warmed.get(root)===job)start(root,job);},650);
  }
  async function prepare(root,producer,key=exportKey(root)){
    const job=jobFor(root,producer,key),entries=await start(root,job);
    if(warmed.get(root)!==job)throw Error('Design changed during preparation');
    const form=root.querySelector('form');if(job.printTiming)form.dataset.msPrintTiming=job.printTiming;
    form.querySelectorAll('[data-design-file],[data-print-file],[data-side-print],[data-print-profile],[data-ms-prepared]').forEach(input=>input.remove());
    for(const [name,value] of entries){
      const input=document.createElement('input');input.name=name;input.hidden=true;input.dataset.msPrepared='';
      if(value instanceof File){input.type='file';const transfer=new DataTransfer();transfer.items.add(value);input.files=transfer.files;}
      else{input.type='hidden';input.value=value;}
      form.append(input);
    }
  }
  const table=new Uint32Array(256);
  for(let n=0;n<256;n++){let c=n;for(let k=0;k<8;k++)c=c&1?0xedb88320^(c>>>1):c>>>1;table[n]=c>>>0;}
  function chunk(type,data){const out=new Uint8Array(data.length+12),view=new DataView(out.buffer);view.setUint32(0,data.length);for(let i=0;i<4;i++)out[4+i]=type.charCodeAt(i);out.set(data,8);let crc=0xffffffff;for(let i=4;i<out.length-4;i++)crc=table[(crc^out[i])&255]^(crc>>>8);view.setUint32(out.length-4,(crc^0xffffffff)>>>0);return out;}
  function numberData(values){const b=new Uint8Array(values.length*4),v=new DataView(b.buffer);values.forEach((n,i)=>v.setUint32(i*4,n));return b;}
  function nativePng(canvas){if(canvas.convertToBlob)return canvas.convertToBlob({type:'image/png'});return new Promise((resolve,reject)=>canvas.toBlob(b=>b?resolve(b):reject(Error('PNG export failed')),'image/png'));}
  async function canvasBlob(canvas){
    if(typeof CompressionStream==='undefined')return nativePng(canvas);
    const width=canvas.width,height=canvas.height,header=new Uint8Array(13);header.set(numberData([width,height]));header[8]=8;header[9]=6;
    const parts=[new Uint8Array([137,80,78,71,13,10,26,10]),chunk('IHDR',header)];
    const stream=new CompressionStream('deflate'),writer=stream.writable.getWriter(),reader=stream.readable.getReader();
    const reading=(async()=>{for(;;){const {value,done}=await reader.read();if(done)break;parts.push(chunk('IDAT',value));}})();reading.catch(()=>{});
    try{
      const ctx=canvas.getContext('2d'),stride=width*4;
      for(let y=0;y<height;y+=128){
        const rows=Math.min(128,height-y),rgba=ctx.getImageData(0,y,width,rows).data,pixels=new Uint32Array(rgba.buffer,rgba.byteOffset,rgba.byteLength/4),raw=new Uint8Array((stride+1)*rows);
        for(let r=0;r<rows;r++){
          let first=0,last=width-1;const row=r*width,src=r*stride,dst=r*(stride+1);
          while(first<width&&pixels[row+first]===0)first++;
          if(first===width)continue;
          while(last>first&&pixels[row+last]===0)last--;
          raw[dst]=1;
          for(let x=first*4,end=Math.min(stride,(last+2)*4);x<end;x++)raw[dst+1+x]=(rgba[src+x]-(x>=4?rgba[src+x-4]:0))&255;
        }
        await writer.write(raw);
      }
      await writer.close();await reading;parts.push(chunk('IEND',new Uint8Array()));return new Blob(parts,{type:'image/png'});
    }catch(error){writer.abort(error).catch(()=>{});reader.cancel(error).catch(()=>{});return nativePng(canvas);}
  }

  window.CartTransferV1 = {begin, send, fail, queue, prepare, encodePng:canvasBlob};
})();

